export const statusMockList = [
    { id: 'Informational', name: 'Informational' },
    { id: 'Successful', name: 'Successful' },
    { id: 'Redirection', name: 'Redirection' },
    { id: 'Client Error', name: 'Client Error' },
    { id: 'Server Error', name: 'Server Error' }
]

export const assigneeMockList = [
    { id: 1, name: 'name@email.com' },
    { id: 2, name: 'name@email.com' },
    { id: 3, name: 'name@email.com' },
    { id: 4, name: 'name@email.com' }
]

export const pathMockList = [
    { id: 1, name: 'myendpoint' },
    { id: 2, name: 'myendpoint' },
    { id: 3, name: 'myendpoint' },
    { id: 4, name: 'myendpoint' }
]

export const httpVerbMockList = [
    { id: 1, name: 'GET' },
    { id: 2, name: 'POST' },
    { id: 3, name: 'PATCH' },
    { id: 4, name: 'DELETE' }
]

export const pluginMockList = [
    { id: 1, name: 'Resource Manager' },
    { id: 2, name: 'Dynamic Risk Advisor' },
    { id: 3, name: 'Channel Manager' }
]

// eslint-disable-next-line prettier/prettier
const mockRes =
    '{"total":4,"data":[{"topEvent":{"id":1,"name":"sdfasdfasf","threats":[{"id":1,"name":"asfsad","initialFrequency":1.0}],"consequences":[{"id":1,"name":"asdfsadfsaf","thresholdFrequency":1.0}]},"hazard":{"id":1,"name":"sdfsfd","operation":{"description":"operation","id":1}},"id":1},{"topEvent":{"id":4,"name":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis"},"hazard":{"id":2,"name":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis","operation":{"description":"operation","id":1}},"id":2},{"topEvent":{"id":7,"name":"a"},"hazard":{"id":3,"name":"a","operation":{"description":"operation","id":1}},"id":3},{"topEvent":{"id":8,"name":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium qui"},"hazard":{"id":13,"name":"a","operation":{"description":"operation","id":1}},"id":4}],"index":0,"size":50,"totalPages":0}'

export const logEventsMockList = [
    {
        timespan: new Date().getTime(),
        httpVerb: 'delete',
        status: 'Informational',
        what: 'Barreira 1',
        assignee: 'Robert',
        response: mockRes
    },
    {
        timespan: new Date().getTime(),
        httpVerb: 'delete',
        status: 'Informational',
        what: 'Barreira 1',
        assignee: 'Robert',
        response: mockRes
    },
    {
        timespan: new Date().getTime(),
        httpVerb: 'delete',
        status: 'Successful',
        what: 'Barreira 1',
        assignee: 'Robert',
        response: mockRes
    },
    {
        timespan: new Date().getTime(),
        httpVerb: 'delete',
        status: 'Informational',
        what: 'Barreira 1',
        assignee: 'Robert',
        response: mockRes
    },
    {
        timespan: new Date().getTime(),
        httpVerb: 'delete',
        status: 'Redirection',
        what: 'Barreira 1',
        assignee: 'Robert',
        response: mockRes
    },
    {
        timespan: new Date().getTime(),
        httpVerb: 'delete',
        status: 'Error',
        what: 'Barreira 1',
        assignee: 'Robert',
        response: mockRes
    },
    {
        timespan: new Date().getTime(),
        httpVerb: 'delete',
        status: 'Error',
        what: 'Barreira 1',
        assignee: 'Robert',
        response: mockRes
    }
]
